"use strict";

var _createClass = require("/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IHeartBeat = void 0;

var events_1 = require("@walletconnect/events");

var IHeartBeat = /*#__PURE__*/function (_events_1$IEvents) {
  _inherits(IHeartBeat, _events_1$IEvents);

  var _super = _createSuper(IHeartBeat);

  function IHeartBeat(opts) {
    _classCallCheck(this, IHeartBeat);

    return _super.call(this);
  }

  return _createClass(IHeartBeat);
}(events_1.IEvents);

exports.IHeartBeat = IHeartBeat;